import React from 'react';
import { Link, Box} from '@mui/material';
import Image from '../custom_image/Image';
import { LogoPropTypes, LogoDefaultProps } from './Logo.propTypes';

// Import the SVG images directly
import CalcasLogoHeader from '../../../icons/svg/calcas-logo.svg';
import CalcasLogoFooter from '../../../icons/svg/CalCas logo horiz RGB white letters-01 1.svg';

/**
 * Logo component
 *
 * @param {Object} props - Logo component props
 * @param {number|string} props.logowidth - Width of the logo
 * @param {number|string} props.logoheight - Height of the logo
 * @param {string} props.logoType - Type of the logo (header, footer, custom)
 * @param {string} [props.customPath] - Path for the custom logo
 * @param {string} [props.href] - Link for the custom logo
 * @param {string} [props.alt] - Alt text for the logo
 * @returns {React.Element} React Element
 */
const Logo = ({
  logowidth,
  logoheight,
  logoType,
  customPath,
  href = '/',
  alt,
  sx,
}) => {
  let logoSrc;
  let altText;

  if (logoType === 'header') {
    logoSrc = CalcasLogoHeader;
    altText = alt || 'California Casualty Header Logo'; // Default value for header
  } else if (logoType === 'footer') {
    logoSrc = CalcasLogoFooter;
    altText = alt || 'California Casualty Footer Logo'; // Default value for footer
  } else {
    logoSrc = customPath;
    altText = alt; // Required for custom logo
  }

  const handleLogoClick  = () => {
    window.location.href = href;
  }

  const logoElement = (
    <Image
      src={logoSrc}
      alt={altText}
      width={logowidth}
      height={logoheight}
      loading="lazy"
    />
  );

  return (
    <Box sx={sx}>
      {logoType !== 'footer' ? (
        <Link component="button" onClick={handleLogoClick}>{logoElement}</Link>
      ) : (
        logoElement
      )}
    </Box>
  );
};

Logo.propTypes = LogoPropTypes;
Logo.defaultProps = LogoDefaultProps;

export default Logo;
